import Quill from "quill";
import toolbarOptions from "@/toolbar-options";

export default {
  name: "Editor",

  props: ["id", "value", "options"],

  data: () => ({
    editor: null
  }),

  render(createElement) {
    var self = this;

    return createElement("div", {
      domProps: {
        value: self.value
      },
      on: {
        input: function(event) {
          self.$emit("input", event.target.value);
        }
      },
      class: {
        "editor-class": true,
        "is-disabled": false
      },
      attrs: {
        id: this.id || "editor",
        placeholder: this.placeholder
      },
      ref: "editor"
    });
  },

  mounted: function() {
    console.log(this.$refs);

    this.editor = new Quill(this.$refs.editor, {
      modules: {
        toolbar: toolbarOptions
      },
      theme: "snow"
    });

    this.editor.root.innerHTML = this.value;

    this.editor.on("text-change", () => this.update());
  },

  methods: {
    update() {
      this.$emit(
        "input",
        this.editor.getText() ? this.editor.root.innerHTML : ""
      );
    }
  },

  beforeDestory: function() {
    this.editor = null;
  }
};
